export default "__VITE_ASSET__758H6ay8__"